export const IS_SHOW_CUSTOM_STATUS_TOUR_LOCALSTORAGE_KEY = 'is-show-custom-status-tour';
